import { render, staticRenderFns } from "./consumptionrecords.vue?vue&type=template&id=189fcd9a&scoped=true&"
import script from "./consumptionrecords.vue?vue&type=script&lang=js&"
export * from "./consumptionrecords.vue?vue&type=script&lang=js&"
import style0 from "./consumptionrecords.vue?vue&type=style&index=0&id=189fcd9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189fcd9a",
  null
  
)

export default component.exports